// extracted by mini-css-extract-plugin
export default {"noBackground":"Oia-z","qnaContainer":"Pia-z","qna":"Qia-z","question":"Ria-z","modal":"Sia-z"};